<template>
	<div :class="['input-container', { 'input-container-dense': dense }]">
		<button @click="less()">
			-
		</button>

		<span class="label">
			{{ Label }}
		</span>

		<input @keydown="filterKey" v-model="inputModel" @change="change()" />

		<button @click="more()">
			+
		</button>
	</div>
</template>

<script>
export default {
	props: {
		value: [String, Number],

		min: {
			value: Number,
			default: 1,
		},

		interval: {
			value: Number,
			default: 1,
		},

		dense: {
			type: Boolean,
			required: false,
		},

		label: {
			type: String,
		},
	},

	data() {
		return {
			max: 17500,
		};
	},

	methods: {
		filterKey(event) {
			const allowedKey = [8, 37, 39, 46].includes(event.keyCode);

			if (!allowedKey && !/^[0-9]$/.test(event.key)) {
				event.preventDefault();
			}
		},

		less() {
			if (parseInt(this.inputModel) - 1 < this.min) {
				return alert(`El valor minimo permitido es: ${this.min}`);
			}

			this.inputModel = this.getPreviousAmountValid(this.inputModel);
		},

		more() {
			if (parseInt(this.inputModel) + 1 > this.max) {
				return alert(`El valor maximo permitido es de: ${this.max}`);
			}

			this.inputModel = this.getNexAmountValid(this.inputModel);
		},

		getNexAmountValid(amount) {
			while (true) {
				amount = parseInt(amount) + 1;

				if (this.theAmountIsValid(amount)) {
					break;
				}
			}

			return amount;
		},

		getPreviousAmountValid(amount) {
			while (true) {
				amount = parseInt(amount) - 1;

				if (this.theAmountIsValid(amount)) {
					break;
				}
			}

			return amount;
		},

		theAmountIsValid(amount) {
			if (this.interval) {
				return parseInt(amount) % this.interval === 0 ? true : false;
			}

			return true;
		},

		change() {
			let amount = parseInt(this.inputModel);

			if (amount >= this.min && amount <= this.max) {
				if (!this.theAmountIsValid(amount)) {
					let newAmountValid = this.getNexAmountValid(amount);

					if (
						confirm(
							`La cantidad para este artículo debe ser un multiplo de: ${this.min}\n¿Quíere cambiar su cantidad de ${this.inputModel} a ${newAmountValid}?`
						)
					) {
						amount = newAmountValid;
					} else {
						amount = this.min;
					}
				}
			}

			if (amount < this.min) {
				alert(`El valor mínimo permitido es: ${this.min}`);

				amount = this.min;
			}

			if (amount > this.max) {
				alert(`El valor maximo permitido es: ${this.max}`);

				amount = this.max;
			}

			this.inputModel = amount;
		},
	},

	computed: {
		inputModel: {
			get() {
				return this.value;
			},

			set(newValue) {
				this.$emit("input", newValue);
			},
		},

		Label() {
			let label = this.label;

			if (this.inputModel > 1) {
				label = `${label}s`;
			}

			return `${label}:`;
		},
	},
};
</script>

<style lang="css" scoped>
.input-container {
	display: flex;
	width: 100%;
	position: relative;
	border: 1px solid #ddd;
}

.input-container button {
	width: 50px;
	height: 50px;
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: 1.4rem;
	font-weight: 600;
	cursor: pointer;
	background-color: #eee;
}

.input-container button:hover {
	background-color: #ccc;
}

.input-container button::selection {
	background: transparent;
}

.label {
	width: 80px;
	display: flex;
	color: #000;
	align-items: center;
	justify-content: flex-end;
	text-align: right;
}

input {
	height: 50px;
	font-size: 1rem;
	margin-right: 2px;
	text-align: center;
	border: none;
	width: calc(100% - 180px);
}

input:focus {
	outline: none !important;
	border: none !important;
}

.input-container input:focus {
	outline: 1px solid #999;
}

/*Dense*/
.input-container-dense input {
	height: 43px;
}

.input-container-dense button {
	height: 43px;
}
</style>
